import React from "react";
import { Box, Typography } from "@material-ui/core";

const CategoryHeader = ({
    title,
    subtitle,
}: {
    title?: string;
    subtitle?: string;
}): JSX.Element => {
    return (
        <Box pb={2}>
            {title && <Typography variant="h4">{title}</Typography>}
            {subtitle && <Typography variant="h5">{subtitle}</Typography>}
        </Box>
    );
};

export default CategoryHeader;
